// Category-emoji labels for the catalog filter tabs. The cards themselves
// (and the API-record → card-props mapping) now come from @astro/course-card.

/** Emoji per course-category slug for filter tabs. */
const CATEGORY_EMOJI = {
  astrology: '🔮',
  'vedic-astrology': 'ॐ',
  'horoscope-reading': '🔮',
  palmistry: '✋',
  'palm-reading': '✋',
  'face-reading': '🀄',
  vastu: '🏠',
  'vastu-shastra': '🏠',
  numerology: '🔢',
  tarot: '🃏',
  relationships: '❤️',
  'career-counseling': '💼',
  'gems-stone-guidance': '💎',
  'kundli-matching': '💍',
  muhurat: '📿',
  'prashna-kundali': '📜',
}

export const categoryEmoji = (slugOrName) => {
  const slug = String(slugOrName).toLowerCase().replace(/[^a-z0-9]+/g, '-')
  return CATEGORY_EMOJI[slug] ?? '📖'
}
